import { isDefined } from "@perxis-auto/shared/lib/lib/is/isDefined";
import { createSelector } from "@reduxjs/toolkit";
import { CreditType } from "../../../../shared/api/types.gen.js";
import { cleanObject } from "../../../../shared/lib/utils/cleanObject.js";
import { selectSlice as selectSlice$1 } from "../../../../shared/store/config/model/selectors/selectSlice.js";
import "../../../../shared/store/config/model/slice.js";
import { selectSlice } from "../../../../features/choice/model/selectors/selectSlice.js";
const selectFinancialProgramsParams = createSelector(
  [selectSlice, selectSlice$1],
  (choice, config) => {
    if (!choice.type || !choice.price || choice.downPayment === null || choice.numberOfPeriods === null || choice.type === CreditType.RESIDUAL_PAYMENT && choice.residualPayment === null) {
      return;
    }
    const formattedCreditParams = config.creditParamsFormatter(choice);
    let filteredCreditParams = {};
    if (typeof formattedCreditParams !== "undefined") {
      filteredCreditParams = cleanObject(formattedCreditParams, choice);
    }
    const params = {
      type: choice.type || CreditType.ANNUITY,
      present_value: choice.price,
      number_of_periods: choice.numberOfPeriods,
      down_payment: Math.round(choice.downPayment),
      ...filteredCreditParams
    };
    if (isDefined(choice.residualPayment)) {
      params.residual_payment = Math.round(choice.residualPayment);
    }
    if (choice.model) {
      params.model = choice.model;
    }
    return params;
  }
);
export {
  selectFinancialProgramsParams
};
